export default __webpack_public_path__ + "static/media/cotton-icon.63feccfc.svg";